import React from 'react';
import classNames from 'classnames';
import { Icon } from '../Icon/Icon';

interface Props {
  id: string;
  label: string;
  type: string;
  placeholder: string;
  onChange: (value: string) => void;
  value: string;
  className?: string;
  error?: string | boolean;
  showErrorOutLine?: boolean; // Case where we need the ability to show error outline if the input is 1 of 2 inputs
  isReadonly?: boolean;
  maxLength?: number; // Restricts number of characters that can be entered into the input field
}

export const TextInput = (props: Props) => {
  const {
    id,
    label,
    type,
    placeholder,
    onChange,
    value,
    className,
    error,
    showErrorOutLine,
    isReadonly,
    maxLength,
  } = props;

  return (
    <div
      className={classNames('TextInput', className, { hasError: (!!error || showErrorOutLine), isDisabled: isReadonly })}
    >
      <label htmlFor={id}>
        <span className="TextInput-label">{label}</span>

        <input
          id={id}
          name={id}
          type={type}
          placeholder={placeholder}
          onChange={(e) => {
            onChange(e.target.value || '');
          }}
          value={value || ''}
          readOnly={isReadonly}
          disabled={isReadonly}
          min="0"
          maxLength={maxLength}
        />

        {/* Error message */}
        {error && (
          <span className="TextInput-error">
            <Icon name="ic-exclamation" />{error}
          </span>
        )}
      </label>
    </div>
  );
};
